import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyReturnPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/returnpolicy" */
      '.'
    ),
);
